export const statuses = [
  'pending',
  'assigned',
  'answered',
  'archived',
  'on_hold',
  'help_requested',
  'help_answered',
  'archived_auto',
];
